// extracted by mini-css-extract-plugin
module.exports = {"orderCard":"OrderList_orderCard__wo4TW","hidden":"OrderList_hidden__eiEsQ","orderInfoContainer":"OrderList_orderInfoContainer__IVKvJ"};